<template>
    <div id="workspace_setting_info" class="vx-card p-6">
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <h3>Chi tiết Workspace</h3>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
                <div class="vx-row">
                    <div class="vx-col w-full mt-2">
                        <label class="vs-input--label required">{{ $t('menuWorspaceSetting.nameIconApp')}}</label>
                        <vs-input class="w-full" v-model="workspaceInfo.nameIconApp" v-validate="'required'"
                                  :placeholder="$t('menuWorspaceSetting.placeholder')" name="nameIconApp">
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('nameIconApp') }}</span>
                    </div>
                    <div class="vx-col w-full mt-2">
                        <label class="vs-input--label required">{{ $t('menuWorspaceSetting.urlApp')}}</label>
                        <vs-input class="w-full" v-model="workspaceInfo.urlApp" v-validate="'required'"
                                  :placeholder="$t('menuWorspaceSetting.placeholder')" name="urlApp">
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('urlApp') }}</span>
                    </div>
                    <div class="vx-col w-full mt-2">
                        <label class="vs-input--label required">{{ $t('menuWorspaceSetting.orders')}}</label>
                        <vs-input class="w-full" v-model="workspaceInfo.orders" v-validate="'required|numeric'"
                                  :placeholder="$t('menuWorspaceSetting.placeholder')" name="ordersApp">
                        </vs-input>
                        <span class="text-danger text-sm">{{ errors.first('ordersApp') }}</span>
                    </div>
                    <div class="vx-col w-full mt-2">
                        <label class="vs-input--label">{{ $t('menuWorspaceSetting.descriptionApp')}}</label>
                        <vs-textarea v-model="workspaceInfo.descriptionApp" :placeholder="$t('menuWorspaceSetting.placeholder')"/>
                    </div>
                </div>
            </div>
            <!--Images-->
            <div class="vx-col md:w-1/2 w-full text-center md:mt-0 mt-4">
                <label class="vs-input--label required">Icon</label>
                <div class="flex justify-center">
                    <vue-upload-multiple-image class="m-auto ml-auto" @upload-success="uploadSuccess"
                                               @before-remove="beforeRemove" @data-change="dataChange"
                                               :data-images="images" :multiple="false" :maxImage="1">
                    </vue-upload-multiple-image>
                </div>
            </div>
        </div>

        <!--buttons-->
        <div class="vx-row mt-8">
            <div class="vx-col w-full ">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto" @click="saveWorkspacee">
                        {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                    </vs-button>
                    <vs-button class="ml-4" type="border" color="warning" @click="$router.go(-1)">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import VueUploadMultipleImage from '../../../components/VueUploadMultipleImage';

export default {
    name: "WorkspaceSettingInfo",
    components: {
        VueUploadMultipleImage,
    },
    data() {
        return {
            workspaceInfo: {
                nameIconApp: null,
                orders: null,
                descriptionApp: null,
                urlApp: null,
            },
            images: [],
            isUpdate: false,
        }
    },

    async created() {
        let id = parseInt(this.$route.query.id, 10)
        if (id) {
            await this.getDetailsWorkspace(id);
            this.isUpdate = true;
            for (const x of this.workspaceInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                this.images.push({
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: 1,
                    file: file,
                    type: 1,
                });
            }
        }
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    methods: {
        async uploadSuccess(formData, index, fileList,) {
            this.images = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.images = fileList;
            this.setIsUpdateImages();
            done();
        },

        dataChange() {
            // this.images = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },

        async saveWorkspacee(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.images.length === 0) {
                return this.$vs.notify({
                    text: 'Bắt buộc phải có 1 ảnh icon workspace!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }

            let formData = new FormData();
            const blob = new Blob([JSON.stringify(this.workspaceInfo)], {type: 'application/json'});
            formData.append('dto', blob);
            this.images.forEach(x => formData.append('images', x.file));

            let url = this.isUpdate ? `/setting/update` : `/setting/create`;
            this.$vs.loading();

            this.$crm.post(url, formData).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật thành công!' : 'Tạo mới thành công!'}`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
                this.$router.push('/user/workspace-setting');
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        getDetailsWorkspace(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post(`/setting/find-by-id/${id}`).then(res => {
                    this.workspaceInfo = res.data;
                    resolve(res);
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err);
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },
    }
}
</script>

<style>
.required:after {
    content: " *";
    color: red;
}
</style>
